import { authApi } from './authApi';

export const createTerritory = async (payload: any) => {
  return await authApi.post('admin/territory/', payload);
};

export const fetchTerritoryMaster = async ({
  params,
}: {
  params?: string;
}): Promise<any> => {
  return await authApi.get(`admin/territory/${params ? params : ''}`);
};

export const deleteTerritoryMaster = async (payload: { ids: number[] }) => {
  return await authApi.delete(`admin/territory/`, {
    data: payload,
  });
};

export const editTerritoryData = async (payload: any) => {
  return await authApi.patch(`admin/territory/${payload?.id}/`, payload?.body);
};

export const updateTerritoryStatus = async (payload: any) => {
  return await authApi.patch(`admin/territory/status_update/`, payload);
};

// product config
export const fetchTerritoryConfig = async (): Promise<any> => {
  return await authApi.get('admin/territory_config/');
};

export const territoryConfigCreate = async (payload: any) => {
  return await authApi.post('admin/territory_config/', payload);
};

export const editTerritoryConfig = async (payload: any) => {
  return await authApi.patch(
    `admin/territory_config/${payload?.id}/`,
    payload?.body
  );
};
